import React, { useState } from 'react'
import { Box, H5, P } from 'ui/bend'
import { Flex } from 'ui/acro'
import styled from 'styled-components'
import { PageHeader, PageLayout } from 'components_v2/SupportPages/__shared__'
import EditorialGrid from 'components_v1/EventsView/EditorialGrid'
import EventFilters from 'components_v1/EventsView/EventFilters'
import LocationDrawer from 'components_v1/EventsView/LocationDrawer'
import MyEvents from 'components_v1/EventsView/MyEvents'
import PastEvents from 'components_v1/EventsView/PastEvents'

const ContentLayout = styled.div`
  flex-direction: column;
  width: 100%;
  max-width: 90%;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 1320px) {
    padding: 24px 16px 0 16px;
    max-width: 100%;
  }
`
const EventCount = styled.div`
  color: #3b3b3b;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
  margin: 12px 0;
`

const HLine = styled.div`
  padding: 24px 0 0 0;
  border-top: 1px solid #a3a3a3;
  margin-top: 72px;
`

const EventsPage = ({
  eventsData = {},
  isLoading,
  isError,
  onRegistrationChange,
  loadNextPageData,
  selectedFilter,
  setSelectedFilter,
  selectedRegion,
  setSelectedRegion,
  currentPageMine,
  currentPageUpcoming,
  currentPagePast,
  paginationLloading,
  setPaginationLloading
}) => {
  const [showLocation, setLocation] = useState(false)
  const showMyEvents = eventsData?.myEvents?.data?.length > 0
  const showPastEvents = eventsData?.past?.data?.length > 0
  const hasUpcoming = eventsData?.upcoming?.data?.length > 0

  return (
    <>
      <Box
        py={['40px', null, '89px']}
        backgroundColor='#F2F2F2'
        textAlign='center'
      >
        <PageLayout>
          <PageHeader
            title='Events'
            style={{
              fontSize: '48px',
              fontWeight: 600,
              lineHeight: '56px',
              letterSpacing: '-1.44px'
            }}
          />
          <P
            color='primary'
            textAlign='center'
            mt='16px'
            mx='auto'
            fontSize={['15px', null, '18px']}
            lineHeight='160%'
            textTransform='uppercase'
          >
            Discover in-person Alo experiences curated for our member community.
          </P>
        </PageLayout>
      </Box>

      <ContentLayout>
        <Box py={['32px', null, '56px']}>
          {showMyEvents && (
            <MyEvents
              events={eventsData?.myEvents?.data || []}
              totalCount={eventsData?.myEvents?.pagination?.totalCount}
              loadNextPageData={loadNextPageData}
              currentPage={currentPageMine}
            />
          )}

          {!isLoading && (
            <>
              {/* <H5
                as='h2'
                mb={['24px', null, '32px']}
                style={{ color: '#000', fontSize: '20px' }}
              >
                Upcoming Events
              </H5>  */}
              {eventsData?.myEvents?.pagination?.totalCount > 0 && <HLine />}
              <EventFilters
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
                setLocation={setLocation}
                selectedRegion={selectedRegion}
              />
            </>
          )}

          {isLoading ? (
            <Flex justifyContent='center' py='48px'>
              <H5 as='div'>Loading events...</H5>
            </Flex>
          ) : isError ? (
            <Flex justifyContent='center' py='48px'>
              <H5 as='div'>Unable to load events. Please try again later.</H5>
            </Flex>
          ) : !hasUpcoming ? (
            <Flex justifyContent='center' py={showPastEvents ? '24px' : '48px'}>
              <H5 as='div'>No upcoming events.</H5>
            </Flex>
          ) : (
            <>
              {eventsData?.upcoming?.pagination?.totalCount && (
                <EventCount style={{ marginBottom: '4px' }}>
                  {eventsData?.upcoming?.pagination?.totalCount} Events
                </EventCount>
              )}
              <EditorialGrid
                events={eventsData?.upcoming?.data || []}
                loadNextPageData={loadNextPageData}
                currentPage={currentPageUpcoming}
                totalPages={eventsData?.upcoming?.pagination?.totalPages}
                onRegistrationChange={onRegistrationChange}
                paginationLloading={paginationLloading}
                setPaginationLloading={setPaginationLloading}
              />
            </>
          )}

          {showPastEvents && (
            <PastEvents
              events={eventsData?.past?.data}
              totalCount={eventsData?.past?.pagination?.totalCount}
              loadNextPageData={loadNextPageData}
              currentPage={currentPagePast}
            />
          )}
        </Box>
        <LocationDrawer
          isOpen={showLocation}
          onClose={() => {
            setLocation(false)
          }}
          selectedRegion={selectedRegion}
          onSelectRegion={setSelectedRegion}
        />
      </ContentLayout>
    </>
  )
}

export default EventsPage
